<template>
    <div class="row container-fluid">
        <!--<section class="content-header">
            <div class="row">
                <div class="col-md-12">
                    <h1>{{ $t('general.servicio') }}</h1>
                </div>

            </div>
            <br>
        </section>-->
        <p style="margin-bottom:0rem;font-size:xx-small">&nbsp;</p>
        <div v-if="spinner==true" class="spinner"></div>
        <section class="content" id="contenido" style="width:100%;">

            <div class="row">
                <div v-show="mostrarlateral == true" class="col-md-2"><!-- style="max-width:12%;flex:0 0 12%"-->
                    <servicio-lateral :estadospendientes="estadospendientes" :servicioext="servicioext" :id="id"
                        :servicio="servicio" :tramitador="tramitador" :asegurado="asegurado" :fecha="fecha"
                        :estilo="estilo" :tramitaraux="tramitaraux" :perito="perito" :perito_pendiente_asignacion="perito_pendiente_asignacion"
                        :permisosusuario="permisosusuario" :trigger-recarga="trigger_recarga_lateral"/>
                </div>
                <div :class="miclase"><!--style="max-width:88%;flex:0 0 88%"-->
                    <div class="row" :style="miestilodos">
                        <div class="col-md" style="min-width:16.67%;max-width:16.67%" v-show="mostrarlateral == false">
                            <servicio-lateral :mostrarsoloservicio="true" :estadospendientes="estadospendientes"
                                :servicioext="servicioext" :id="id" :servicio="servicio" :tramitador="tramitador"
                                :asegurado="asegurado" :fecha="fecha" :estilo="estilo" :tramitaraux="tramitaraux"
                                :perito="perito" :perito_pendiente_asignacion="perito_pendiente_asignacion" :permisosusuario="permisosusuario" :trigger-recarga="trigger_recarga_lateral"/>
                        </div>
                        <div class="col-md">
                            <servicio-lateral-asegurado :id="id" :servicio="servicio" :asegurado="asegurado" />
                        </div>
                        <div class="col-md">
                            <div class="info-box">
                                <span title="Dirección" class="info-box-icon bg-info elevation-1" style="width:50px;height:50px;margin-top:5px"><i
                                        class="fas fa-map-marker-alt"></i></span>
                                <div class="info-box-content" v-if="asegurado && asegurado.direccion && asegurado.direccion.length<50">
                                    <span class="info-box-text" style="font-size:1rem"
                                        :title="'Dirección: ' + asegurado.direccion + ' ' + asegurado.poblacion + ' ' + asegurado.codigo_postal + ' ' + asegurado.provincia">{{asegurado.direccion}}</span>
                                    <span class="info-box-text" style="font-size:small"
                                        :title="'Dirección: ' + asegurado.direccion + ' ' + asegurado.poblacion + ' ' + asegurado.codigo_postal + ' ' + asegurado.provincia">{{asegurado.poblacion}}
                                        {{asegurado.codigo_postal}} {{asegurado.provincia}} &nbsp;&nbsp; {{kms}} </span>
                                   <!-- <span title="Distancia" style="font-size:small" class="info-box-text">{{ kms
                                        }}&nbsp;</span>-->
                                </div>
                                 <div class="info-box-content" v-if="asegurado && asegurado.direccion && asegurado.direccion.length>=50">
                                    <span class="info-box-text" style="font-size:1rem"
                                        :title="'Dirección: ' + asegurado.direccion + ' ' + asegurado.poblacion + ' ' + asegurado.codigo_postal + ' ' + asegurado.provincia">{{ asegurado.direccion.substr(0, 46)}}...</span>
                                    <span class="info-box-text" style="font-size:0.9rem"
                                        :title="'Dirección: ' + asegurado.direccion + ' ' + asegurado.poblacion + ' ' + asegurado.codigo_postal + ' ' + asegurado.provincia">{{asegurado.poblacion}}
                                        {{asegurado.codigo_postal}} {{asegurado.provincia}} &nbsp;&nbsp; {{kms}} </span>
                                   <!-- <span title="Distancia" style="font-size:small" class="info-box-text">{{ kms
                                        }}&nbsp;</span>-->
                                </div>
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="info-box" style="font-size:small;">
                                <span title="Fechas" class="info-box-icon bg-success elevation-1" style="width:50px;height:50px;margin-top:5px"><i
                                        class="fas fa-calendar-day"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text"><b>Fecha Asignado </b>{{ fecha1 }}</span>
                                    <span class="info-box-text"><b>Fecha Actualiza </b>{{ fecha_actualiza }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md" v-if="servicio.contrato ">
                            <div class="info-box" title="Contrato" style="font-size:small">
                                <span title="Contrato" class="info-box-icon bg-danger elevation-1" style="width:50px;height:50px;margin-top:5px"><i
                                        class="fas fa-file-contract"></i></span>
                                <div class="info-box-content">
                                    <span :title="'Contrato: '+servicio.contrato" class="info-box-text">{{
                                        servicio.contrato
                                        }}</span>
                                    <span :title="'Cobertura: '+servicio.cobertura" class="info-box-text">
                                        {{ servicio.cobertura}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div style="max-width: 350px" class="col-md" v-if="servicio.siniestros_relacionados">
                            <div class="info-box" title="Expedientes relacionados">
                                <span title="Siniestros relacionados" class="info-box-icon bg-warning elevation-1" style="width:50px;height:50px;margin-top:5px"><i
                                        style="color:white" class="fas fa-link"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text"><b>{{servicio.siniestros_relacionados.length}}</b>&nbsp;
                                        <a href="#"><i @click="toggle" class="fas fa-angle-down"></i></a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-default card-tabs" :style="miestilo">
                        <div class="card-header p-1 pt-1">
                            <ul class="nav nav-pills">
                                <li class="nav-item"><a class="nav-link"
                                        @click="mostrarf2(); secciondatos = true;seccionpresupuestos = false; cargaseccion = !cargaseccion; guardarpestanyaactiva('datos')"
                                        href="#datos_servicio" data-toggle="tab">{{$t('general.datos')}}</a></li>
                                <li class="nav-item" v-if="tramitaraux == false || comuSinTram"><a class="nav-link"
                                        @click="mostrarf2(); seccioncomunicaciones = true;seccionpresupuestos = false;guardarpestanyaactiva('comunicaciones');cargarcomunicaciones+=1"
                                        href="#comunicaciones_servicio"
                                        data-toggle="tab">{{$t('general.comunicaciones')}}</a></li>
                                <li v-if="mostrarplanning==true && tramitaraux == false" class="nav-item"><a
                                        class="nav-link"
                                        @click="comprobartipodano(); mostrarf(); seccionplanning = true;seccionpresupuestos = false;guardarpestanyaactiva('planning');cargarplanning+=1"
                                        href="#planning_servicio" data-toggle="tab">{{ $t('general.planning') }}</a>
                                </li>
                                <li class="nav-item" v-if="tramitaraux ==false"><a class="nav-link"
                                        @click="mostrarf2(); seccionincidencias = true;seccionpresupuestos = false;guardarpestanyaactiva('incidencias')"
                                        href="#incidencias_servicio" data-toggle="tab">{{$t('general.incidencias')}}</a>
                                </li>
                                <li v-if="encuestas && tramitaraux == false" class="nav-item"><a class="nav-link"
                                        @click="mostrarf2(); seccionEncuestas = true;seccionpresupuestos = false;guardarpestanyaactiva('encuestas')"
                                        href="#encuestas_servicio" data-toggle="tab">Encuestas</a>
                                </li>
                                <li class="nav-item" v-if="tramitaraux ==false"><a class="nav-link"
                                        @click="mostrarf2(); seccionInforme = true;seccionpresupuestos = false;guardarpestanyaactiva('informe')"
                                        href="#informe_servicio" data-toggle="tab">Informe fotográfico</a>
                                </li>
                                <li class="nav-item" v-if="tramitaraux ==false"><a class="nav-link"
                                        @click="mostrarf2(); seccionadjuntos = true;seccionpresupuestos = false;guardarpestanyaactiva('adjuntos')"
                                        href="#adjuntosemail_servicio" data-toggle="tab">{{$t('general.adjuntos')}}</a>
                                </li>
                                <li class="nav-item" v-if="tramitaraux ==false && permitirpedidos == true"><a
                                        class="nav-link"
                                        @click="mostrarf2(); seccionpedidos = true;seccionpresupuestos = false; guardarpestanyaactiva('pedidos')"
                                        href="#pedidos_servicio" data-toggle="tab">{{$t('general.pedidos')}}</a>
                                </li>
                               <!-- <li class="nav-item" v-if="tramitaraux ==false"><a class="nav-link"
                                        @click="mostrarf2(); seccionnotas = true;seccionpresupuestos = false;guardarpestanyaactiva('notas')"
                                        href="#notas_servicio" data-toggle="tab">{{$t('general.notas') }}</a>
                                </li>-->
                                <li class="nav-item" v-if="tramitaraux == false && !plataforma && eliminado==false"><a
                                        class="nav-link"
                                        @click="mostrarf2(); seccionpresupuestos = true;guardarpestanyaactiva('presupuestos')"
                                        href="#presupuestos_servicio"
                                        data-toggle="tab">{{$t('general.presupuestos')}}</a>
                                </li>
                                <li class="nav-item" v-if="tramitaraux == false && !plataforma && eliminado==false"><a
                                        class="nav-link"
                                        @click="mostrarf2(); secciontrabajos = true;seccionpresupuestos = false; auxtrabajos = !auxtrabajos; guardarpestanyaactiva('trabajos')"
                                        href="#trabajos_servicio" data-toggle="tab">{{ $t('general.trabajos') }}</a>
                                </li>
                                <li class="nav-item"
                                    v-if="tramitaraux == false && factoadmin && !plataforma && eliminado==false"><a
                                        class="nav-link"
                                        @click="cargarfacturacion(); mostrarf2(); seccionfacturacion = true;seccionpresupuestos = false; guardarpestanyaactiva('facturacion')"
                                        href="#facturacion_servicio" data-toggle="tab">{{
                                        no_factura==1?'Registro':$t('general.facturacion')}}</a>
                                </li>
                                <li class="nav-item" v-if="accesoweb == true"><a class="nav-link"
                                        :title="'Acceso a '+servicio.compania.sistema" style="color:#007bff"
                                        @click="iralaweb()" href="#"><i class="fas fa-globe"></i>&nbsp;WEB</a>
                                </li>
                                <li class="nav-item" v-if="servicio.estado == 'Activo'"><a class="nav-link"
                                        style="color:#dc3545" @click="comprobarvisitas()" href="#"><i
                                            class="fas fa-times"></i>&nbsp;Eliminar</a>
                                </li>
                                <li class="nav-item" v-if="servicio.estado && servicio.estado != 'Activo'"><a
                                        class="nav-link" style="color:#28a745" @click="recuperarexpediente()"
                                        href="#"><i class="fa fa-recycle"></i>&nbsp;Recuperar</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--<br>-->
                    <div class="tab-content">
                        <div class="tab-pane" id="datos_servicio">
                            <servicio-datos @email="email" :cargaseccion="cargaseccion" :perito="perito" :id="id"
                                :asegurado="asegurado" :servicioext="servicioext"
                                @actualizarperjudicado="cargardatos(0,0,true)" @actualizar="actualizarPagina()"
                                :servicio="servicio" v-if="secciondatos==true" :perjudicados="perjudicados"
                                @actualizarasegurado="cargardatos(0,0,true)" />
                        </div>
                        <div class="tab-pane" id="comunicaciones_servicio">
                            <div class="card">
                               <!-- <div class="card-header bg-gray" v-show="losburrosvuelan">
                                    <h3 class="card-title"><i class="fab fa-telegram-plane mr-2"></i>Comunicaciones</h3>
                                    <div class="card-tools">
                                        <button @click="minimizar" ref="botoncolapso" type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                 </div>-->
                                <div class="card-body">
                                    <comunicaciones :minimizarprop="minimizarprop" :visitasinterpwgs="visitasinterpwgs" :cargar="cargarcomunicaciones" :servicio="servicio"
                                            v-if="seccioncomunicaciones==true" :id="id" />
                                </div>
                            </div>
                            <notas :id="id" :servicio="servicio" v-if="seccioncomunicaciones == true " />
                            <!--<comunicaciones  :visitasinterpwgs="visitasinterpwgs" :cargar="cargarcomunicaciones" :servicio="servicio"
                                v-if="seccioncomunicaciones==true && (!direccionglobal.includes('demored') && !direccionglobal.includes('null.pwgs.app'))" :id="id" />-->
                        </div>
                        <div class="tab-pane" id="planning_servicio">
                            <planning :servicioext="servicioext" :asegurado="asegurado" :cargar="cargarplanning" :id="id"
                                v-if="seccionplanning==true" :servicio="servicio" @visita-creada="onVisitaCreada"/>
                        </div>
                        <div class="tab-pane" id="presupuestos_servicio">
                            <presupuestos :id="id" @enviado="actualizarPagina()" v-if="seccionpresupuestos==true" :servicio="servicio" />
                        </div>
                        <div class="tab-pane" id="pedidos_servicio">
                            <pedidos :id="id" :servicio="servicio" v-if="seccionpedidos==true" @email="email" />
                        </div>
                        <div class="tab-pane" id="trabajos_servicio" style="padding-top: 2%;">
                            <trabajosrealizados :actualizarfacturado="actualizarfacturado" :auxtrabajos="auxtrabajos"
                                :id="id" v-if="secciontrabajos==true" :servicio="servicio" />
                        </div>
                        <div class="tab-pane" id="adjuntosemail_servicio">
                            <adjuntosemail @enviado="actualizarPagina()" :idemail='idemail' :id="id" :servicio="servicio" :asegurado="asegurado"
                                v-if="seccionadjuntos==true" />
                        </div>
                        <div class="tab-pane" id="facturacion_servicio" style="padding-top: 1.5%;">
                            <facturacion ref="fact" :ffac="ffac" :id="id" :servicioext="servicioext"
                                :servicio="servicio" v-if="seccionfacturacion==true" @facturado="facturado" />
                        </div>
                       <!--<div class="tab-pane" id="notas_servicio">
                            <notas :id="id" :servicio="servicio" v-if="seccionnotas == true" />
                        </div>-->
                        <div class="tab-pane" id="incidencias_servicio">
                            <incidencias :id="id" :servicio="servicio" v-if="seccionincidencias == true" />
                        </div>
                        <div class="tab-pane" id="encuestas_servicio">
                            <encuestas :id="id" :servicio="servicio" v-if="seccionEncuestas == true" />
                        </div>
                        <div class="tab-pane" id="informe_servicio">
                            <informefotografico :id="id" :servicio="servicio" v-if="seccionInforme == true" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <Dialog ref="datosvisita" modal class="midialogo" header="Datos de la visita" :style="{ width: '30vw' }"
        :closeOnEscape="false" v-model:visible="visibleDatosVisita" closable>
        <div style="display: flex; gap: 10px">
            <label for="">Fecha:</label>
            <span>{{visitacreada.fecha}}</span>
        </div>
        <div style="display: flex; gap: 10px">
            <label for="">Hora:</label>
            <span>{{ visitacreada.hora }}</span>
        </div>
        <div style="display: flex; gap: 10px">
            <label for="">Operario:</label>
            <span>{{ visitacreada.operario }}</span>
        </div>
        <div style="display: flex; gap: 10px">
            <label for="">Fecha creación expediente:</label>
            <span>{{ visitacreada.fecha_creacion }}</span>
        </div>
        <div style="display: flex; gap: 10px">
            <label for="">Máximo horas:</label>
            <span>{{ visitacreada.horas_max }}</span>
        </div>
        <div style="display: flex; gap: 10px">
            <label for="">Fecha máxima primera cita:</label>
            <span>{{ visitacreada.fecha_max }}</span>
        </div>
        <div style="display: flex; justify-content: end; gap: 10px">
            <button v-if="waActivado" class="btn btn-sm btn-light" style="border: 1px solid grey"
                @click="enviarAutovisita('enviar_whatsapp')">Whatsapp</button>
            <button class="btn btn-sm btn-light" style="border: 1px solid grey"
                @click="enviarAutovisita('realizar_llamada')">Llamada</button>
            <button class="btn btn-sm btn-light" style="border: 1px solid grey"
                @click="enviarAutovisita('enviar_sms')">SMS</button>
            <button class="btn btn-sm btn-light" style="border: 1px solid grey"
                @click="visibleDatosVisita = false">Cerrar</button>
        </div>
    </Dialog>
    <Dialog ref="midialogo" position="bottom" class="midialogo" header="Tramitar Expediente" :style="{ width: '50vw' }"
        :closeOnEscape="false" :closable="false" v-model:visible="visible">
        <!-- <template #closeicon>
            <p @click="cerrarpestanya()">X</p>
        </template>-->
        <div class="row" v-if="servicio.nota_importante">
            <p style="background:#80808099;text-align:center"><b>NOTA:</b> {{ servicio.nota_importante}}<br></p>
        </div>
        <div class="row">
            <p>
                <b>Expediente:</b> {{ servicio.codigo_original}}<br>
                <b>Daños:</b> {{ servicio.danos}}<br>
                <b>NIF:</b> {{ servicio.asegurado.nif}}<br>
                <b>Póliza:</b> {{ servicio.asegurado.poliza}}<br>
                <span v-if="servicio.contrato"><b>CONTRATO: </b>{{ servicio.contrato }}</span><br  v-if="servicio.contrato">
                <span v-if="servicio.tipo_servicio"><b>TIPO: </b>{{ servicio.tipo_servicio }}</span><br v-if="servicio.tipo_servicio">
                <span v-if="servicio.fecha_asignacion"><b>FECHA ASIGNACIÓN: </b>{{ servicio.fecha_asignacion }}</span><br  v-if="servicio.fecha_asignacion">
                <span v-if="servicio.cobertura"><b>COBERTURAS: </b>{{ servicio.cobertura }}</span><br v-if="servicio.cobertura">
                <span v-if="servicio.limite_autonomia"><b>LIMITES DE AUTONOMÍA: </b><span  v-html="servicio.limite_autonomia"></span></span><br v-if="servicio.limite_autonomia">
                <span v-if="servicio.asignacion"><b>ASIGNACIÓN: </b><span v-html="servicio.asignacion"></span></span><br v-if="servicio.asignacion">
            </p>        </div>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <Button style="width:100%" label="Tramitar Expediente" @click="mostrartramitar()"></Button>
            </div>
        </div>
    </Dialog>
    <Dialog ref="dialogobloqueo" modal :closable="false" class="midialogo" header="Servicio ocupado"
        :style="{ width: '30vw' }" :closeOnEscape="false" v-model:visible="visiblebloqueado">
        <div class="row">
            <p style="text-align:center"><b>Servicio ocupado por el usuario
                    {{servicio.bloqueo.nombre_usuario}} {{servicio.bloqueo.tiempo}}</b><br><br></p>
        </div>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <Button style="width:80%" @click="asignarmebloqueo()"><i
                        class="fas fa-sign-out-alt"></i>&nbsp;&nbsp;&nbsp;<b>Echar</b></Button>
            </div>

        </div>
    </Dialog>
    <Dialog header="Seleccionar especialidad 1ra visita" modal :style="{ width: '25vw' }"
        v-model:visible="visibleprimeravisita">
        <div class="row">
            <div class="col-md-2"></div>
            <b>Especialidad</b>
        </div>
        <div class="row">
            <div class="col-md-2"></div>
            <select v-model="especialidadseleccionada" style="width:18rem" class="form-control input-sm">
                <option v-for="especialidades in servicio.autovisita.especialidades"
                    :key="especialidades.idespecialidad" :value="especialidades.idespecialidad">
                    {{especialidades.nombre}}</option>

            </select>
        </div>
        <div class="row">&nbsp;</div>
        <div class="row">
            <div class="col-md-2"></div>
            <b>Tipo de daño</b>

        </div>
        <div class="row">
            <div class="col-md-2"></div>
            <select v-model="danoseleccionado" style="width:18rem" class="form-control input-sm">
                <option v-for="tipodano in servicio.autovisita.tipos_danyo" :key="tipodano.id_tipo_danyo"
                    :value="tipodano.id_tipo_danyo">{{tipodano.danyo}}</option>

            </select>
        </div>
        <div class="row">&nbsp;</div>
        <div class="row" style="gap: 5px;">
            <div class="col-md-2"></div>
            <b style="margin: 0;">Urgente</b>
            <input type="checkbox" v-model="urgenteVisita" v-bind:true-value="1" v-bind:false-value="0">
        </div>
        <div class="row">&nbsp;</div>
        <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-4">
                <Button style="width:100%" label="Guardar" @click="empezartramitar()"></Button>
            </div>
            <div class="col-md-4"
                v-if="this.servicio.autovisita && this.servicio.autovisita.autovisita_obligatoria != 1"> <Button
                    style="width:100%" label="Cerrar" @click="tramitarexpediente();this.visitacreada=null"></Button>
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="confirmacionEliminacion" modal :header="eliminarserviciotext" :style="{ width: '600px' }">
        <div style="display: grid; gap: 10px;">
            <textarea class="form-control" rows="2" placeholder="Indique motivo de eliminación (opcional)" v-model="motivoEliminacion"></textarea>
            <div style="display: flex; gap: 10px; justify-content: end;">
                <button class="btn btn-sm btn-danger" @click="eliminarexpediente">Eliminar</button>
                <button class="btn btn-sm btn-light" @click="confirmacionEliminacion = false">Cancelar</button>
            </div>
        </div>
    </Dialog>
    <OverlayPanel ref="rela">
        <h5 style="text-align:center">Expedientes relacionados</h5>
        <table>
            <tbody>
                <tr v-for="expediente in servicio.siniestros_relacionados" :key="expediente.id_servicio">
                    <td>
                        <a href="#" style="color:blue"
                            @mouseover="toggledatos($event);obtenerDatosRelacionados(expediente.id_servicio);"
                            @click="irServicio(expediente.id_servicio,expediente.codigo)"> {{
                            expediente.codigo }} </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </OverlayPanel>
    <OverlayPanel ref="reladatos" style="width:50%">
        <span v-if="datosrelacionados.descripcion"><b>Descripción:</b>&nbsp;{{datosrelacionados.descripcion}}<br></span>
        <span v-if="datosrelacionados.importe_facturado"><b>Importe
                Facturado:</b></span>&nbsp;{{datosrelacionados.importe_facturado}}<br>
        <span v-if="datosrelacionados.fecha_inicio"><b>Fecha inicio:</b>&nbsp;{{datosrelacionados.fecha_inicio}}</span>
        <span v-if="datosrelacionados.fecha_cierre"><b>Fecha cierre:</b>&nbsp;{{datosrelacionados.fecha_cierre}}</span>
    </OverlayPanel>
      <form id="TheFormWebAntigua" method="get" :action="direccionglobaldos" target="ifrm1">
    </form>
    <iframe id="ifrm1" name="ifrm1" style="display:none"></iframe>
</template>
<script>
import $ from 'jquery';
import { PwgsApi } from '../../../services/PwgsApi';
import serviciolateral from './lateral/lateral.vue';
import serviciodatos from './datos/datos.vue';
import comunicaciones from './comunicaciones/comunicaciones.vue';
import presupuestos from './presupuestos/presupuestos.vue';
import planning from './planning/planning.vue';
import trabajosrealizados from './trabajosrealizados/TrabajosRealizados.vue';
import facturacion from './facturacion/Facturacion.vue';
import pedidos from '../pedidos/PedidosLista.vue';
import adjuntosemail from './adjuntosemail/adjuntosemail.vue';
import notas from './notas/notas.vue';
import encuestas from './encuestas/encuestas.vue';
import incidencias from './incidencias/incidencias.vue';
import Dialog from 'primevue/dialog';
import informefotografico from './informefotografico/informefotografico.vue';
import serviciolateralasegurado from './lateral/lateral_asegurado.vue';
import OverlayPanel from 'primevue/overlaypanel';
export default ({
        props: ['id'],

    setup() {     
    },
    components: {
        'servicio-lateral': serviciolateral,
        'servicio-datos': serviciodatos,
        'comunicaciones': comunicaciones,
        'presupuestos': presupuestos,
        'planning': planning,
        'encuestas': encuestas,
        informefotografico,
        trabajosrealizados,
        facturacion,
        pedidos,
        adjuntosemail,
        notas,
        incidencias,
        Dialog,
        OverlayPanel,
        'servicio-lateral-asegurado': serviciolateralasegurado,
        
        
        
    },
    data() {
        return {
            confirmacionEliminacion:false,
            motivoEliminacion: '',
            no_factura: localStorage.getItem('no_factura'),
            waActivado:false,
            accesoweb: false,
            idemail:null,
            eliminado:false,
            comuSinTram:false,
            urgenteVisita:0,
            visibleDatosVisita:false,
            actualizarfacturado:1,
            cargarplanning:1,
            cargarcomunicaciones:1,
            estadoscargados:false,
            gestorDocsActivado: true,
            encuestas:false,
            servicio: '',
            perjudicados: [],
            tramitador: [],
            asegurado: [],
            fecha: '',
            auxtrabajos:true,
            ffac: 0,
            mostrarplanning:true,
            mostrar: false,
            visiblebloqueado:false,
            servicioext: '',
            miclase: "col-md-10",
            mostrarlateral: true,
            estadospendientes: [],
            visible: false,
            danoseleccionado:'',
            visitacreada: '',
            especialidadseleccionada:[],
            clasedifuminado:"row",
            visibleprimeravisita: false,
            accionseleccionada: '',
            error: false,
            direccionglobal: 'https://' + localStorage.getItem('direccion'),
            direccionglobaldos:'https://desarrollofront.pwgs.app',
            visitaerror: false,
            tramitaraux: false,
            secciondatos: false,
            seccioncomunicaciones:false,
            seccionplanning:false,
            seccionpresupuestos:false,
            seccionpedidos: false,
            secciontrabajos:false,
            seccionadjuntos:false,
            seccionfacturacion:false,
            seccionnotas:false,
            seccionincidencias: false,
            tramitadoaux: false,
            seccionEncuestas:false,
            seccionGestor:false,
            seccionInforme: false,
            permitirpedidos: true,
            rutaventana: '',
            kms: '',
            fechas: '',
            fecha1: '',
            fecha_actualiza: '',
            perito:'',
            content:'content',
            spinner: true,
            factoadmin:true,
            plataforma:false,
            permisosusuario:[],
            peritocargado:false,
            noactivar: false,
            miestilo: '',
            miestilodos: '',
            webgenerali: '',
            cargaseccion: true,
            datosrelacionados:'',
            perito_pendiente_asignacion:'',
            visitasinterpwgs:'',
            minimizarprop: false,
            trigger_recarga_lateral: 0,
        }
    },
    methods: {
        minimizar(){
           /* var minim = localStorage.getItem('minimizado_comunicaciones');
            console.log('min',minim);
            if(minim == 1){
                localStorage.setItem('minimizado_comunicaciones',0);
            }else{
                console.log('entra');
                localStorage.setItem('minimizado_comunicaciones',1);
            }*/
           this.minimizarprop = !this.minimizarprop;
        },
        async obtenerDatosRelacionados(idservicio) {
            //GET /servicios/:id_servicio_relacionado/info-relacionado
            const api = new PwgsApi();
            this.datosrelacionados = await api.get('servicios/' + idservicio + '/info-relacionado');
            
        },
        async iralaweb() { 
            /*this.urlnovedad = this.direccionglobal + 'validar_web_generali.php?relog='+this.servicio.compania.id;
            let aux = window.open('', 'TheWindow');
            document.getElementById('TheFormdos').submit();
            setTimeout(() => {
                aux.location.href = this.urlnovedad;

            }, 1000);*/




            const api = new PwgsApi();
            if (this.servicio.compania.sistema == "GENERALI") {
                let aux = await api.get('servicios/' + this.$props.id + '/login-generali');
                this.webgenerali = aux.web_generali;
                this.direccionglobal = this.webgenerali;
                setTimeout(() => {
                    let auxweb = window.open('', 'TheWindowweb');
                    auxweb.location.href = "https://www.generali.es/spgwLogout";
                    setTimeout(() => {

                        auxweb.location.href = this.webgenerali;

                    }, 500);

                }, 500);
                //document.getElementById('TheFormweb').submit();


            }

            if (this.servicio.compania.sistema == "MULTIASISTENCIA_WS") {
                let codigooriginal = this.servicio.codigo_original;
                
                document.getElementById('TheFormWebAntigua').submit();
                setTimeout(() => {
                    let ventanados = window.open(this.direccionglobal + "/validar_web_multiasistencia.php?id_servicio=" + this.$props.id);
                    setTimeout(() => {
                        ventanados.location.href= this.direccionglobal + '/expediente_web_multiasistencia.php?expediente='+codigooriginal;

                    }, 4000);
                }, 2000);
            }
        },
        
        email(id){
            this.idemail = id;
            this.mostrarf2(); 
            this.seccionadjuntos = true;
            this.guardarpestanyaactiva('adjuntos');
            this.cargarpestanyaactiva();
        },
          async comprobarvisitas() {
            const api = new PwgsApi;
            this.motivoEliminacion = "";
            this.tienevisitas = await api.get('servicios/' + this.$props.id + '/tiene-visitas-pendientes');
            if (this.tienevisitas.tiene_visitas_pendientes == 1) {
                this.eliminarserviciotext = "El servicio tiene visitas. ¿Desea eliminar el servicio "+this.servicio.codigo+"?";
               
            }
            else {
                this.eliminarserviciotext = "¿Desea eliminar el servicio "+this.servicio.codigo+"?";
            }
            this.confirmacionEliminacion = true;
        },
        async eliminarexpediente() {
            const api = new PwgsApi();
            let auxmostrar = this.tramitaraux;
            try {
                await api.put('servicios/' + this.$props.id + '/elimina', { motivo: this.motivoEliminacion });
                this.$toast.add({ severity: 'success', summary: 'Eliminado', detail: 'Servicio eliminado correctamente', life: 2000 });
                this.confirmacionEliminacion = false;
                this.cerrarpestanya();
                this.cargardatos(this.$props.id, 'activ', true);
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                this.confirmacionEliminacion = false;
            }
            this.tramitaraux = auxmostrar;
        },
        async recuperarexpediente() {
            const api = new PwgsApi();
            if (confirm('Desea recuperar el expediente ' + this.servicio.codigo)) {
                               let auxmostrar = this.tramitaraux;

                try {
                    await api.put('/servicios/' + this.$props.id + '/recupera');
                    this.$toast.add({ severity: 'success', summary: 'Recuperado', detail: 'Servicio recuperado correctamente', life: 2000 });
                                    this.cargardatos(this.$props.id,'visita', true);
                    this.cargarmasdatos();
                    this.mostrarplanning = true;
                   // window.location.reload();
                }
                catch (e) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
                }
                this.tramitaraux = auxmostrar;

            }

        },
        
        actualizarPagina(){
            this.cargardatos(this.$props.id, 'activ', true);
            this.cargarmasdatos();

        },
        facturado(){
            this.actualizarfacturado +=1;
            setTimeout(() => {
                this.cargardatos(this.$props.id, 'activ', true);
                this.cargarmasdatos();
            }, 2000);
        },
        irServicio(id, codigo) {
            localStorage.setItem('nombreservicio' + id, codigo);
            this.$router.push({
                name: 'Servicio',
                params: {
                    id: id,
                    nombreservicio: codigo,
                }
            });
        },
        calcularKMS(){
            if(this.servicio.distancia){
                this.kms = this.servicio.distancia+' KM';
            }
            else{
                this.kms = '';
            }
        },
        cerrarpestanya() {
        
            this.$store.dispatch('quitarRuta', this.rutaventana);
            //this.tramitaraux = true;
            this.$router.push({ name: 'Escritorio' });
           

        },
        cerrarpestanyados() {
            if (this.servicio.tramitado != 1){
            //this.tramitaraux = true;
            this.$router.push({ name: 'Escritorio' });
            }
            
        },
        toggle(event) {
            this.$refs.rela.toggle(event);
        },
         toggledatos(event) {
            this.$refs.reladatos.toggle(event);
        },
        guardarpestanyaactiva(pestanya) {
            localStorage.setItem("pestanyactivaservicio" + this.$props.id, pestanya);
            if(pestanya == 'facturacion' ){
                if (this.$refs.fact) { 
                this.$refs.fact.reload();

                }

            }
            //this.content = 'content';
            //document.getElementById("contenido").style.filter = "none";
            //this.spinner = false;
        },
        async cargarperito(moti) {
            console.log(moti);
            //  modulos/pwgsapi/index.php/servicios/:id/perito
            this.perito = '';
            const api = new PwgsApi;
            this.perito = await api.get("servicios/" + this.$props.id + "/perito");
            this.peritocargado = true;
        },
        cargarpestanyaactiva() {
            let pestanaactiva = localStorage.getItem('pestanyactivaservicio' + this.$props.id);

            if (pestanaactiva == 'datos') {
                this.mostrarf2();
                this.secciondatos = true;
                $('[href="#datos_servicio"]').tab('show');

            }
            if (pestanaactiva == 'comunicaciones') {
                this.mostrarf2();
                this.seccioncomunicaciones = true;
                setTimeout(() => {
                                    $('[href="#comunicaciones_servicio"]').tab('show');

                }, 1000);
                 setTimeout(() => {
                                    $('[href="#comunicaciones_servicio"]').tab('show');

                }, 2000);
                $('[href="#comunicaciones_servicio"]').tab('show');

            }
            if (pestanaactiva == 'planning') {
                this.mostrarf();
                
                this.seccionplanning = true;
                $('[href="#planning_servicio"]').tab('show');

            }
            if (pestanaactiva == 'presupuestos') {
                this.mostrarf2();
                this.seccionpresupuestos = true;
                $('[href="#presupuestos_servicio"]').tab('show');

            }
            if (pestanaactiva == 'pedidos') {
                this.mostrarf2();
                this.seccionpedidos = true;
                $('[href="#pedidos_servicio"]').tab('show');

            }
            if (pestanaactiva == 'trabajos') {
                this.mostrarf2();
                this.secciontrabajos = true;
                $('[href="#trabajos_servicio"]').tab('show');

            }
            if (pestanaactiva == 'facturacion') {
                this.mostrarf2();
                this.seccionfacturacion = true;
                $('[href="#facturacion_servicio"]').tab('show');

            }
            if (pestanaactiva == 'adjuntos') {
                this.mostrarf2();
                this.seccionadjuntos = true;
                $('[href="#adjuntosemail_servicio"]').tab('show');

            }
            if (pestanaactiva == 'notas') {
                this.mostrarf2();
                this.seccionnotas = true;
                $('[href="#notas_servicio"]').tab('show');

            }
            if (pestanaactiva == 'incidencias') {
                this.mostrarf2();
                 this.seccionincidencias = true;
                $('[href="#incidencias_servicio"]').tab('show');

            }
            if (pestanaactiva == 'encuestas') {
                this.mostrarf2();
                this.seccionEncuestas = true;
                $('[href="#encuestas_servicio"]').tab('show');

            }
            if (pestanaactiva == 'gestor') {
                this.mostrarf2();
                this.seccionGestor = true;
                $('[href="#gestor_servicio"]').tab('show');
            }
            if (pestanaactiva == 'informe') {
                this.mostrarf2();
                this.seccionInforme = true;
                $('[href="#informe_servicio"]').tab('show');

            }
        },
        async cargardatos(id,cual, forzar) {
            //  modulos/pwgsapi/index.php/servicios/:id/datos-basicos
            this.visiblebloqueado = false;
            if(!this.servicio || this.servicio.id != this.id || forzar){
                $('[href="#datos_servicio"]').tab('show');
                this.cargarpestanyaactiva();
                this.tramitaraux = false;
                this.error = false;
                const api = new PwgsApi;
                const datos = await api.get("servicios/" + this.$props.id + '/datos-basicos');
                this.servicio = datos;                
                if(this.servicio.estado == "Eliminado"){
                    this.eliminado = true;
                }else{
                    this.eliminado = false;
                }               
                if(this.servicio.tramitado != 1){
                    var sintram = await api.get('parametros-pwgs/comunicaciones_sin_tramitar');
                    if(sintram.comunicaciones_sin_tramitar == 1){
                        this.comuSinTram = true;
                    }
                }
                let ventana = '';
                let ventanaid = this.$props.id.toString();
                let ventanas = this.$store.getters.ventanas;
                for (let i = 0; i < ventanas.length; i++) {
                    ventana = this.$store.getters.ventanas[i].path;
                    if (ventana.includes(ventanaid) && datos.clientes.asegurado) {
                        this.rutaventana = this.$store.getters.ventanas[i];
                        this.$store.getters.ventanas[i].alt = datos.clientes.asegurado.nombre + " || " + datos.clientes.asegurado.direccion;
                    }
                }
                document.getElementById("contenido").style.pointerEvents = "auto";
                if (this.servicio.tramitado != 1) { this.visible = true; }
                if (this.servicio.tramitado == 1) { this.visible = false; }
                this.perjudicados = datos.clientes.perjudicados;
                this.tramitador = datos.tramitador.nombre;
                this.asegurado = datos.clientes.asegurado;
                this.fecha = datos.fecha_espera.fecha;
               /* if(this.servicio.bloqueo){
                    if(this.servicio.bloqueo.estado == 0){
                        this.bloquearservicio('noserv');
                    }
                    if(this.servicio.bloqueo.estado == 1){
                        this.advertirbloqueo();
                    }
                }*/
               await this.comprobarBloqueo();
                if(this.servicio.compania.sistema == "GENERALI"){
                    this.accesoweb = true;
                }
                if(this.servicio.compania.sistema == "MULTIASISTENCIA_WS"){
                    this.accesoweb = true;
                }
                this.perito_pendiente_asignacion = datos.perito_pendiente_asignacion;
            }
        },

        async comprobarGestorDocs(){
            const api = new PwgsApi();
            const resp = await api.get('parametros-pwgs/gestion_doc');
            if(resp.gestion_doc != 1){
                this.gestorDocsActivado = false
            }
        },
        async comprobarEncuestas(){
            const api = new PwgsApi();
            try {
                await api.get('servicios/'+this.$props.id+'/encuestas');
                this.encuestas = true;
            }
            catch (error) {
                if (error == "Error: Token no válido") {
                    api.get('logout');
                    localStorage.removeItem('token');
                    this.$router.push('/login');
                }
                console.error(error);
            }
        },
        tramitarerror(){
            this.tramitarexpediente();
            this.visibleprimeravisita = false;
            },
            comprobartipodano() {//error diego mirar
                if (this.servicioext.datos.tipo_danyo_servicio){
                    this.mostrarf();
                }
                else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: "Debe rellenar el tipo de daño para mostrar el planning", life: 5000 });
                    $('[href="#datos_servicio"]').tab('show');
                    this.mostrarf2()
                }
        },
        async empezartramitar() {
            const api = new PwgsApi()
            let subidadatos = { id_tipo_dano: this.danoseleccionado, id_especialidad: this.especialidadseleccionada , urgente:this.urgenteVisita};
            try {
                this.visitacreada = await api.post('servicios/' + this.$props.id + '/configurar-autovisita', subidadatos);
                this.tramitarexpediente();
            }           
            catch (error) {
                const mensajeError = error?.message || String(error);
                if (mensajeError.includes("Token no válido")) {
                    api.get('logout');
                    localStorage.removeItem('token');
                    this.$router.push('/login');
                    return;
                }
                if (mensajeError.includes("Identificador de")) {
                    console.log("mensajeerror", mensajeError);
                } else {
                    this.servicio.autovisita.autovisita_obligatoria = 0;
                }
                this.$toast.add({ severity: 'error', summary: 'Error', detail: mensajeError, life: 5000 });
                this.error = true;
            }
        },
        activarPestana(pestana) {
            // Desactivamos todas las pestañas.
            $('.nav-link').removeClass('active');
            // Activamos la pestaña deseada.
            $(`[href="#${pestana}_servicio"]`).addClass('active');
            // Desactivamos todas las tab-pane.
            $('.tab-pane').removeClass('active');
            // Activamos la tab-pane deseada.
            $(`#${pestana}_servicio`).addClass('active');
        },
        mostrartramitar() {
            if (this.servicio.autovisita) {
                this.visibleprimeravisita = true;
            }
            else {
                this.tramitarexpediente();
             }
        },
        async enviarAutovisita(accion){
            try{
                const api = new PwgsApi();
                let subidadatosdos = { id_tipo_dano: this.danoseleccionado, id_especialidad: this.especialidadseleccionada, id_visita: this.visitacreada.idvisita, accion: accion }
                await api.put('servicios/' + this.$props.id + '/enviar-autovisita', subidadatosdos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Autovisita enviada', life: 2000 });
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async tramitarexpediente() {
            
            const api = new PwgsApi();
            try{
                await api.put('servicios/' + this.$props.id + '/tramitar');
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Servicio tramitado correctamente', life: 2000 });
                this.tramitadoaux = true;

                this.visible = false;
                this.visibleprimeravisita = false;
                if(this.visitacreada){
                    this.visibleDatosVisita = true;
                }
                this.servicio.tramitado = 1;
                                this.cargardatos(this.$props.id,'visita', true);
                                this.cargarmasdatos();


            }
            catch (error) {
                if (error == "Error: Token no válido") {
                    api.get('logout');
                    localStorage.removeItem('token');
                    this.$router.push('/login');
                }
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                this.tramitadoaux = false;

            }
        },
        async obtenerEstadosPendientes() {
            //GET  modulos/pwgsapi/index.php/tipos-estado-pendiente
            const api = new PwgsApi();
            let resp2 = await api.get('tipos-estado-pendiente');
            this.estadospendientes = [
            {
                label:'Estados pendientes',
                items:resp2.datos.estados_pendientes
            },
            {
                label:'Especialidades',
                items:resp2.datos.especialidades
            }]
            this.estadoscargados = true;
        },
        comprobarFecha() {
            var fechas = this.servicioext.datos.fecha;
            var [ano, mes, dia] = fechas.split('-');
            this.fecha1 = dia.toString() + '/' + mes.toString() + '/' + ano.toString();
        },
     
        async cargarmasdatos() {
            const api = new PwgsApi(); //this.servicioext.datos.fecha_actualiza;
            this.servicioext = await api.get("servicios/" + this.$props.id);
            //let ventana = '';
            //let ventanaid = this.$props.id.toString();
            //let ventanas = this.$store.getters.ventanas;
            //let nombreservicio = "Servicio: " + this.servicioext.datos.codigo;
            var [ano, mes, dia] = this.servicioext.datos.fecha_actualiza.split('-');
            this.fecha_actualiza = dia.toString() + '/' + mes.toString() + '/' + ano.toString();
            //this.fecha_actualiza = new Date(this.servicioext.datos.fecha_actualiza).toLocaleDateString('es');
            /*  for (let i = 0; i < ventanas.length; i++) {
                ventana = this.$store.getters.ventanas[i].path;
                if (ventana.includes(ventanaid)) {
                    this.$store.getters.ventanas[i].name = nombreservicio;
                }
            }*/
            
            if(this.servicioext.datos.estado=="finalizado" || this.servicioext.datos.estado=="eliminado"){
                this.mostrarplanning = false;
            }
        },        
        cargarfacturacion() { 
            this.ffac = this.ffac + 1;
        },
        mostrarf() {
            this.mostrar = true;
            this.mostrarlateral = false;
            this.miclase = "col-md-12"; /*width:83,33%*/
            this.miestilo = "margin-left:16.8%;margin-top:-30px";
           // this.miestilodos = "margin-left:16.25%;width:83,33%";
        },
        mostrarf2() {
            this.mostrarlateral = true;
            this.miclase = "col-md-10";
            this.miestilo = " ";
            this.miestilodos = " ";

            
        },
        async bloquearservicio() {
            const api = new PwgsApi();
            await api.put('servicios/' + this.$props.id + '/abrir');
        },
           async comprobarBloqueo() {
        const api = new PwgsApi();
        const datos = await api.get('servicios/' + this.$props.id + '/datos-basicos');
        this.servicio.bloqueo = datos.bloqueo;

        if (!datos.bloqueo) return;

        if (datos.bloqueo.estado == 0) {
            await this.bloquearservicio();
            this.visiblebloqueado = false;
            return;
        }

        const usuario = String(localStorage.getItem('usuario'));
        if (datos.bloqueo.estado == 1 && usuario !== String(datos.bloqueo.id_usuario)) {
            this.advertirbloqueo();
        } else {
            this.visiblebloqueado = false;
        }
    },
    advertirbloqueo() {
        this.usuarioserviciobloqueado = this.servicio.bloqueo.nombre_usuario;
        document.getElementById("contenido").style.filter = "blur(4px)";
        document.getElementById("contenido").style.pointerEvents = "none";
        this.spinner = true;
        this.visiblebloqueado = true;
    },
        async asignarmebloqueo() {
            const api = new PwgsApi();
            let subidadatos = {echar:1};
            await api.put('servicios/' + this.$props.id + '/abrir',subidadatos);
            document.getElementById("contenido").style.filter = "none";
            this.spinner = false;
            document.getElementById("contenido").style.pointerEvents = "auto";
            this.visiblebloqueado = false;
        },

        async comprobarpermisos(){
            const api = new PwgsApi();
            var wa = await api.get('parametros-pwgs/whatsapp');
            if(wa.whatsapp=='1'){
                this.waActivado = true;
            }else{
                this.waActivado = false;
            }
            let auxusuario = localStorage.getItem('usuario');
            const resppermisos = await api.get('usuarios/'+auxusuario+'/permisos');
            var permisos = resppermisos.datos;
            for(let permiso of permisos){
                this.permisosusuario.push(permiso.nombre_permiso);
            }
            const factencontrado = permisos.find(permiso => permiso.nombre_permiso == "Facturación");
            const adminencontrado= permisos.find(permiso => permiso.nombre_permiso == "Administración");
            const superadminencontrado= permisos.find(permiso => permiso.nombre_permiso == "Super Administración");
            const plat= permisos.find(permiso => permiso.nombre_permiso == "Plataforma");
            if(plat){
                this.plataforma = true;
            }
            if(factencontrado || adminencontrado || superadminencontrado){
                this.factoadmin = true;
            }else{
                this.factoadmin = false;
            }
        },
        cerrarpestanas(pestanaactiva){
            if(pestanaactiva != 'datos'){
                this.secciondatos= false;
            }
            if(pestanaactiva != 'comunicaciones'){
                this.seccioncomunicaciones= false;
            }
            if(pestanaactiva != 'planning'){
                this.seccionplanning=false;
            }
            if(pestanaactiva != 'presupuestos'){
                this.seccionpresupuestos=false;
            }
            if(pestanaactiva != 'pedidos'){
                this.seccionpedidos= false;
            }
            if(pestanaactiva != 'trabajos'){
                this.secciontrabajos=false;
            }
            if(pestanaactiva != 'adjuntos'){
                this.seccionadjuntos=false;
            }
            if(pestanaactiva != 'facturacion'){
                
                this.seccionfacturacion=false;
            }
            if(pestanaactiva != 'notas'){
                
                this.seccionnotas=false;
            }
            if(pestanaactiva != 'incidencias'){
                
                this.seccionincidencias=false;
            }
            if(pestanaactiva != 'encuestas'){
                
                this.seccionEncuestas=false;
            }
            if(pestanaactiva != 'gestor'){
                
                this.seccionGestor=false;
            }
            if(pestanaactiva != 'informe'){
                
                this.seccionInforme= false;
            }
        },
        async cargarInterpwgs(){
            const api = new PwgsApi();
            this.visitasinterpwgs = await api.get('interpwgs-pwgs/'+this.$props.id+'/visitas');
            for(let visita of this.visitasinterpwgs){
                visita.trabajos_realizados_enviar = visita.realizados;
                visita.trabajos_pendientes_enviar = visita.pendientes;
                visita.enviarfirma = 1;
                visita.enviarfinalizacion = 1;
            }
         //   let visitasdos = await api.get('servicios/'+this.$props.id+'/interpwgs');
          //  console.log("visitasdos", visitasdos);
        },
        async onVisitaCreada() {
            await this.cargarmasdatos();
            this.trigger_recarga_lateral++;
        }
    },
    mounted(){    
        document.getElementById("contenido").style.filter = "blur(4px)";
        this.comprobarpermisos();
        this.cargarInterpwgs();
        var min = localStorage.getItem("minimizado_comunicaciones");
        if(min == 1){
            this.$refs.botoncolapso.click();
        }
        window.scrollTo(0, 0);
    },
    created(){
            this.comprobarEncuestas();
            this.comprobarGestorDocs();
        },
    activated() {
        let pestanaactiva = localStorage.getItem('pestanyactivaservicio' + this.$props.id);
        this.cerrarpestanas(pestanaactiva);
        if(!this.noactivar){
         
            this.mostrarplanning = true;
            if(!this.servicioext){
                this.cargarmasdatos();
            }
            if(!this.servicio){
                this.cargardatos(this.$props.id,'activ');
            }
            if (this.servicio) {
             this.comprobarBloqueo();
            }
            if(!this.estadoscargados){
                this.obtenerEstadosPendientes();
            }
            let tipoaux = localStorage.getItem("tiposerv");
            this.calcularKMS();
            if(!this.peritocargado){
                this.cargarperito('activ');
            }
            if(tipoaux == 'solicitud'){
                this.mostrarf2();
                this.seccioncomunicaciones = true;
                this.guardarpestanyaactiva('comunicaciones');
                this.activarPestana('comunicaciones');
                localStorage.setItem("tiposerv", '');
            }
            else if(tipoaux == 'norealizados'){
                    this.mostrarf2();
                    this.seccionnotas = true;
                    this.guardarpestanyaactiva('notas');
                    this.activarPestana('notas');
                    localStorage.setItem("tiposerv", '');
                } else{
                    if(pestanaactiva == "datos" || !pestanaactiva){
                        this.mostrarf2();
                        this.secciondatos = true;
                        this.guardarpestanyaactiva('datos');
                        this.activarPestana('datos');
                        localStorage.setItem("tiposerv", '');
                    }
                }
                setTimeout(() => {
                    this.content = 'content';
                document.getElementById("contenido").style.filter = "none";
                if (this.servicio.id == this.$route.params.id && !this.visiblebloqueado) {
    document.getElementById("contenido").style.filter = "none";
    this.spinner = false;
}
                this.spinner = false;
            }, 2000); 
                
        }
    },
   
    watch: {
        visibleDatosVisita(value){
            if(value == false){
                this.cargardatos(this.$props.id,'visita', true);
            }
        },

        id() {
            window.scrollTo(0, 0);
            this.visible = false;
            let pestanaactiva = localStorage.getItem('pestanyactivaservicio' + this.$props.id);
            this.noactivar=true;
            this.cerrarpestanas(pestanaactiva);
            this.comprobarpermisos();
            this.content = 'spinner';
            document.getElementById("contenido").style.filter = "blur(4px)";
            this.spinner = true;
            
            this.mostrarplanning = true;
            if(this.$props.id){
                this.cargarmasdatos();
                this.cargardatos(this.$props.id,'idd');
                this.obtenerEstadosPendientes();
                this.calcularKMS();
                this.cargarperito('id');
            }
            let tipoaux = localStorage.getItem("tiposerv");
            if(tipoaux == 'solicitud' || tipoaux == 'norealizados'){
                this.mostrarf2();
                this.seccioncomunicaciones = true;
                this.guardarpestanyaactiva('comunicaciones');
                this.activarPestana('comunicaciones');
                localStorage.setItem("tiposerv", '');
            }
            if (pestanaactiva == "datos" || !pestanaactiva) {
                this.mostrarf2();
                this.secciondatos = true;
                this.guardarpestanyaactiva('datos');
                this.activarPestana('datos');
                localStorage.setItem("tiposerv", '');
            }
                
            if (pestanaactiva == 'comunicaciones') {
                this.mostrarf();
            }      
            this.noactivar = false;
               if (this.servicio.compania.sistema != "GENERALI" && this.servicio.compania.sistema != "MULTIASISTENCIA_WS") {
                    this.accesoweb = false;
                }
                   if (this.servicio.compania.sistema == "GENERALI") {
                    this.accesoweb = true;
                   }
                if (this.servicio.compania.sistema == "MULTIASISTENCIA_WS") {
                    this.accesoweb = true;
                }
                           this.cargarInterpwgs();

        },
        servicioext(){
        this.comprobarFecha();
        },
        tramitaraux() {
            localStorage.setItem('tramitado' + this.$props.id, this.tramitaraux);

        },
        servicio() {
            this.calcularKMS();
            this.content = 'spinner';
            document.getElementById("contenido").style.filter = "blur(4px)";
            this.spinner = true;
            if (this.servicio.id == this.$route.params.id) {
                this.content = 'content';
                document.getElementById("contenido").style.filter = "none";
                this.spinner = false;
            }
            if (this.servicio.tramitado == 1) { this.visible = false; }
            localStorage.setItem('tramitado' + this.$props.id, this.tramitaraux);
            if (this.servicio.compania.sistema != "GENERALI" && this.servicio.compania.sistema != "MULTIASISTENCIA_WS") {
                    this.accesoweb = false;
                }
                   if (this.servicio.compania.sistema == "GENERALI") {
                    this.accesoweb = true;
                   }
                if (this.servicio.compania.sistema == "MULTIASISTENCIA_WS") {
                    this.accesoweb = true;
                }
             if (this.servicio.id == this.$route.params.id && !this.visiblebloqueado) {
    document.getElementById("contenido").style.filter = "none";
    this.spinner = false;
}  

        },
        visible() {
            if (this.visible == true) {
                this.clasedifuminado = "row difuminado";
                this.tramitaraux = true;
            }
            if(this.visible == false){
                this.clasedifuminado = "row";
                this.tramitaraux = false;
            }
        },
        $route() {
            this.tramitadoaux = true;
            this.visible = false;
            this.visiblebloqueado = false;
            if(this.$route.name=="Servicio"){
                this.cargarmasdatos();
                this.cargardatos(0,0,true);

                if (this.servicio.tramitado == 1) { this.visible = false; }

                if (this.servicio.tramitado != 1) { this.visible = true; }
            }
              
               
            
        }
    }
})
</script>
<style>

.difuminado{
        filter: blur(6px);
            pointer-events: none;
            -webkit-user-select: none;
                /* Safari */
            -ms-user-select: none;
                /* IE 10 and IE 11 */
            user-select: none;
                /* Standard syntax */
}
.cont{
    
        background:#dc3545 !important

}
.fechasest{
    
        background:#28a745 !important

}
.expr {

    background: #ffc107 !important
}
.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index:1000;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
         
}
.INPUTT{
    max-width:100%;
}
@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
/*.midialogo .p-dialog-header-icons{
    visibility: hidden;
}**/
</style>